import { onboarding } from '@services';

interface IRequest {
  groupId: string;
  studioId: string;
  fileId: string;
  status: string;
  triggeredByEmail?: string;
  triggeredBy?: string;
}

const patchAccessory = async ({
  status,
  groupId,
  fileId,
  studioId,
  triggeredBy,
  triggeredByEmail,
}: IRequest): Promise<void> => {
  await onboarding.patch(
    `/api/v1/assets/status?groupId=${groupId}&status=${status}&studioId=${studioId}&fileId=${fileId}&triggeredBy=${triggeredBy}&triggeredByEmail=${triggeredByEmail}`,
  );
};

export { patchAccessory };
